import { FC, useEffect, useState } from 'react';
import { Modal, Typography } from 'melp-design/components';
import { ModalProps } from 'store/modal';
import { formatDuration } from 'utils/format';
import { useTranslation } from 'react-i18next';
import { useSignout } from 'store/auth';

interface Props extends ModalProps {
  expiresAt: number;
  closeModal: (param?: { action: 'CLOSE' } | { action: 'CONFIRM' }) => void;
}

export const SessionTimeoutModal: FC<Props> = ({ expiresAt, closeModal }) => {
  const { t, i18n } = useTranslation();
  const [now, setNow] = useState(() => Date.now());

  const { mutate: signout, isLoading: isSigningOut } = useSignout();

  useEffect(() => {
    const intervalId = window.setInterval(() => setNow(Date.now()), 250);
    return () => window.clearInterval(intervalId);
  }, []);

  const seconds = Math.ceil(Math.max(0, expiresAt - now) / 1000);

  return (
    <Modal.Content
      title={t('session.expiring.title')}
      actions={[
        {
          variant: 'secondary',
          label: t('common.logout'),
          onClick: () => {
            signout(undefined, { onSuccess: () => closeModal() });
          },
          loading: isSigningOut,
        },
        {
          variant: 'primary',
          label: t('common.continue'),
          onClick: () => closeModal({ action: 'CONFIRM' }),
          disabled: isSigningOut,
        },
      ]}
    >
      <Typography variant="p1" color="textSecondary" component="span">
        {t('session.expiring.message', {
          time: formatDuration(i18n.language, seconds, 'second'),
        })}
      </Typography>
    </Modal.Content>
  );
};
